import { render, staticRenderFns } from "./SlideVerify.vue?vue&type=template&id=3dbf20bc&scoped=true&"
import script from "./SlideVerify.vue?vue&type=script&lang=js&"
export * from "./SlideVerify.vue?vue&type=script&lang=js&"
import style0 from "./SlideVerify.vue?vue&type=style&index=0&id=3dbf20bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbf20bc",
  null
  
)

component.options.__file = "SlideVerify.vue"
export default component.exports